import { EnumLang } from './constant';

export const globalState = {
  visitInfo: {
    appkey: '',
    visitId: '',
    basicLoginUrl: '',
    // 增加国际化通参
    region: '',
    locale: EnumLang.ZhHK,
    cityId: '',
  },
  // 已选择的订单
  selectedOrder: null,
  // 首页订单类型
  homeOrderType: null,
  currentRoute: '',
  tips: {
    LeaveChat: '',
  },
};
